import React, { useEffect, useState } from "react";
import { Table, Button, message, Space, Typography, Tag, Tooltip, Modal, Select } from "antd";
import { unassignVehicleFromClient } from "../../api/vehicle/vehicleRequest";
import { getMessageError } from "../../utils/messageUtils";
import {
  PlusOutlined,
  EyeOutlined,
  DisconnectOutlined,
} from "@ant-design/icons";
import { getCountryNameByCode } from "../../utils/countries";
import PermissionRender from "../../components/PermissionRender";
import AssignVehicle from "../../components/AssignVehicle";

const { Option } = Select;
const { Title } = Typography;

const VehicleTable = ({ vehicles, onClientUpdate, clientId }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);
  const [vehicleToUnassign, setVehicleToUnassign] = useState(null);

  

  const showUnassignConfirmation = (vehicle) => {
    setVehicleToUnassign(vehicle);
    setConfirmModalVisible(true);
  };

  const handleConfirmUnassign = async () => {
    try {
      await unassignVehicleFromClient(vehicleToUnassign.id);
      message.success("Véhicule détaché avec succès");
      onClientUpdate();
      setConfirmModalVisible(false);
    } catch (error) {
      console.error("Erreur:", error);
      getMessageError(
        error.response?.data?.error,
        "Erreur lors du détachement du véhicule"
      );
    }
  };

  const vehicleColumns = [
    {
      title: "Matricule",
      dataIndex: "matricule",
      key: "matricule",
      width: 120,
      fixed: 'left',
    },
    {
      title: "Pays",
      dataIndex: "country",
      key: "country",
      width: 80,
      render: (countryCode) => getCountryNameByCode(countryCode) || "-",
    },
    {
      title: "Marque",
      dataIndex: "brand",
      key: "brand",
      width: 100,
      render: (brand) => brand || "-",
    },
    {
      title: "Modèle",
      dataIndex: "model",
      key: "model",
      width: 100,
      render: (model) => model || "-",
    },
    {
      title: "Couleur",
      dataIndex: "color",
      key: "color",
      width: 80,
      render: (color) => color || "-",
    },
    {
      title: "Abonnements Actifs",
      dataIndex: "active_subscriptions",
      key: "active_subscriptions",
      width: 200,
      render: (activeSubscriptions) => {
        if (!activeSubscriptions || activeSubscriptions.length === 0) {
          return <Tag color="default">Aucun</Tag>;
        }
        return (
          <Space direction="vertical" size="small">
            {activeSubscriptions.map((subscription) => (
              <Tooltip
                key={subscription.id}
                title={`Contrat: ${subscription.contract_number || 'N/A'} | Début: ${subscription.start_date} | Fin: ${subscription.end_date}`}
              >
                <Tag color="green">
                  {subscription.subscription_type?.name || 'Type inconnu'}
                </Tag>
              </Tooltip>
            ))}
          </Space>
        );
      },
    },
    {
      title: "Abonnements en Attente",
      dataIndex: "pending_subscriptions",
      key: "pending_subscriptions",
      width: 200,
      render: (pendingSubscriptions) => {
        if (!pendingSubscriptions || pendingSubscriptions.length === 0) {
          return <Tag color="default">Aucun</Tag>;
        }
        return (
          <Space direction="vertical" size="small">
            {pendingSubscriptions.map((subscription) => (
              <Tooltip
                key={subscription.id}
                title={`Contrat: ${subscription.contract_number || 'N/A'} | Début: ${subscription.start_date} | Fin: ${subscription.end_date}`}
              >
                <Tag color="orange">
                  {subscription.subscription_type?.name || 'Type inconnu'}
                </Tag>
              </Tooltip>
            ))}
          </Space>
        );
      },
    },
    
    {
      title: "Action",
      key: "action",
      width: 150,
      fixed: 'right',
      render: (text, record) => (
        <Space>
          <Button
            type="primary"
            ghost
            icon={<EyeOutlined />}
            size="small"
            onClick={() => window.open(`/vehicle/${record.id}`, "_blank")}
          >
            Voir
          </Button>
          <PermissionRender requiredPermission={["vehicles", "update"]}>
            <Button
              type="danger"
              ghost
              icon={<DisconnectOutlined />}
              size="small"
              onClick={() => showUnassignConfirmation(record)}
            >
              Détacher
            </Button>
          </PermissionRender>
        </Space>
      ),
    },
  ];

  return (
    <div className="vehicle-table-container">
      <div
        style={{
          marginBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Title level={4} style={{ margin: 0 }}>
          Véhicules assignés
        </Title>
        <PermissionRender requiredPermission={["vehicles", "update"]}>
          <AssignVehicle clientId={clientId} onAssigned={onClientUpdate} />
        </PermissionRender>
      </div>
      <Table
        columns={vehicleColumns}
        dataSource={vehicles}
        rowKey="id"
        pagination={false}
        locale={{ emptyText: "Aucun véhicule trouvé" }}
        bordered
        scroll={{ x: 1400, y: 400 }}
        style={{ borderRadius: "4px", overflow: "hidden" }}
        className="custom-vehicle-table"
      />

      

      {/* Confirmation Modal */}
      <Modal
        title="Confirmer le détachement"
        open={confirmModalVisible}
        onOk={handleConfirmUnassign}
        onCancel={() => setConfirmModalVisible(false)}
        okText="Détacher"
        cancelText="Annuler"
        okButtonProps={{ danger: true }}
      >
        <p>
          Êtes-vous sûr de vouloir détacher le véhicule{" "}
          <strong>
            {vehicleToUnassign?.matricule} - {vehicleToUnassign?.brand}{" "}
            {vehicleToUnassign?.model}
          </strong>
          ?
        </p>
      </Modal>
    </div>
  );
};

export default VehicleTable;
